import { FormConfig, FormFieldConfig } from '../components/DynamicForm';

/**
 * 表单配置管理器
 * 用于管理表单配置的增删改查
 */
class FormConfigManager {
  private storageKey: string;

  constructor(storageKey: string = 'formConfigs') {
    this.storageKey = storageKey;
  }

  /**
   * 获取所有表单配置
   */
  getAllConfigs(): FormConfig[] {
    try {
      const configsJson = localStorage.getItem(this.storageKey);
      return configsJson ? JSON.parse(configsJson) : [];
    } catch (error) {
      console.error('获取表单配置失败:', error);
      return [];
    }
  }

  /**
   * 根据ID获取表单配置
   */
  getConfigById(id: string): FormConfig | null {
    const configs = this.getAllConfigs();
    return configs.find(config => config.id === id) || null;
  }

  /**
   * 保存表单配置
   */
  saveConfig(config: FormConfig): boolean {
    try {
      const configs = this.getAllConfigs();
      const index = configs.findIndex(c => c.id === config.id);

      if (index >= 0) {
        // 更新现有配置
        configs[index] = config;
      } else {
        // 添加新配置
        configs.push(config);
      }

      localStorage.setItem(this.storageKey, JSON.stringify(configs));
      return true;
    } catch (error) {
      console.error('保存表单配置失败:', error);
      return false;
    }
  }

  /**
   * 删除表单配置
   */
  deleteConfig(id: string): boolean {
    try {
      const configs = this.getAllConfigs();
      const filteredConfigs = configs.filter(config => config.id !== id);
      
      if (filteredConfigs.length === configs.length) {
        // 没有找到要删除的配置
        return false;
      }

      localStorage.setItem(this.storageKey, JSON.stringify(filteredConfigs));
      return true;
    } catch (error) {
      console.error('删除表单配置失败:', error);
      return false;
    }
  }

  /**
   * 创建新的字段配置
   */
  createField(options: Partial<FormFieldConfig>): FormFieldConfig {
    return {
      key: options.key || `field_${Date.now()}`,
      label: options.label || '新字段',
      type: options.type || 'input',
      required: options.required !== undefined ? options.required : false,
      placeholder: options.placeholder,
      defaultValue: options.defaultValue,
      rules: options.rules || [],
      options: options.options,
      props: options.props
    };
  }

  /**
   * 创建新的表单配置
   */
  createConfig(options: Partial<FormConfig>): FormConfig {
    return {
      id: options.id || `form_${Date.now()}`,
      name: options.name || '新表单',
      description: options.description,
      fields: options.fields || []
    };
  }
}

// 导出单例实例
export const formConfigManager = new FormConfigManager();

// 导出类型
export type { FormConfig, FormFieldConfig }; 